<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getUnfactoredClaimsHeader ()"
    :items="unfactoredClaims"
    :loading="loadingUnfactoredClaims"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.Name }} ehf (kt. {{ props.item.Kennitala | kennitala }})</td>
      <!--<td class="text-xs-left">{{ props.item.Account | account }}</td>-->
      <td class="text-xs-right">{{ props.item.DueDate | date }}</td>
      <td class="text-xs-right">{{ props.item.FinalDueDate | date }}</td>
      <td class="text-xs-right">{{ props.item.Capital | amount }}</td>
      <!--<td class="text-xs-right">{{ props.item.Created | date}}</td>-->
      <td class="text-xs-right">
        <TwoStateButton
          :item="props.item"
          class="btn"
          @changeState="changeState" />
      </td>
      <template slot/>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
import TwoStateButton from '../controllers/TwoStateButton.vue';
    export default {
        name: "UnfactoredClaimsDatagrid",
        components: {TwoStateButton, DataGridSort},
        props: ['unfactoredClaims','loadingUnfactoredClaims','rowsPerPage'],
        data () {
          return {
            pagination:
                    {
                      sortBy: 'finalDueDate',
                      descending: true
                    }
          }
        },
        methods: {
            getUnfactoredClaimsHeader ()
            {
                return [
                    {sortable: true, text: this.$t('krita.claims.namekennitala'), value: 'debtorRegistryId', align: 'left'},
                    // {sortable: true, text: 'Account', value: 'account', align: 'left'},
                    {sortable: true, text: this.$t('krita.claims.duedate'), value: 'dueDate', align: 'right'},
                    {sortable: true, text: this.$t('krita.claims.finalduedate'), value: 'finalDueDate', align: 'right'},
                    {sortable: true, text: this.$t('krita.claims.capital'), value: 'amount', align: 'right'},
                    {sortable: false, text: '', value: 'placeholder', align: 'right'}
                ]
            },
            changeState (item)
            {
                let self = this;

                self.$emit('changeUnfactoredClaimsStatus',item)
            },
          changeSort (sort)
          {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
          }
        }
    }
</script>

<style lang="css" scoped>
    .btn {
        width:100px;
        max-width:100px;
    }
</style>
